// Static team lists for the favorite-team picker (NFL/MLB/NBA).
// ESPN's team-list JSON API blocks server-side/edge traffic (Akamai WAF), but logo images
// are public CDN assets and load fine directly, so we hardcode abbreviations here instead.
const logoUrl = (league, abbr) => `https://a.espncdn.com/i/teamlogos/${league}/500/${abbr}.png`;

const NFL_ABBREVIATIONS = [
  "ari", "atl", "bal", "buf", "car", "chi", "cin", "cle", "dal", "den",
  "det", "gb", "hou", "ind", "jax", "kc", "lv", "lac", "lar", "mia",
  "min", "ne", "no", "nyg", "nyj", "phi", "pit", "sf", "sea", "tb",
  "ten", "wsh",
];

const MLB_ABBREVIATIONS = [
  "ari", "ath", "atl", "bal", "bos", "chc", "chw", "cin", "cle", "col",
  "det", "hou", "kc", "laa", "lad", "mia", "mil", "min", "nym", "nyy",
  "phi", "pit", "sd", "sf", "sea", "stl", "tb", "tex", "tor", "wsh",
];

const NBA_ABBREVIATIONS = [
  "atl", "bos", "bkn", "cha", "chi", "cle", "dal", "den", "det", "gs",
  "hou", "ind", "lac", "lal", "mem", "mia", "mil", "min", "no", "ny",
  "okc", "orl", "phi", "phx", "por", "sac", "sa", "tor", "utah", "wsh",
];

export const NFL_TEAM_LOGOS = NFL_ABBREVIATIONS.map((abbr) => logoUrl("nfl", abbr));
export const MLB_TEAM_LOGOS = MLB_ABBREVIATIONS.map((abbr) => logoUrl("mlb", abbr));
export const NBA_TEAM_LOGOS = NBA_ABBREVIATIONS.map((abbr) => logoUrl("nba", abbr));

const toTeamPairs = (league, abbreviations) =>
  abbreviations.map((abbr) => ({ name: abbr.toUpperCase(), logo: logoUrl(league, abbr) }));

export const NFL_TEAMS = toTeamPairs("nfl", NFL_ABBREVIATIONS);
export const MLB_TEAMS = toTeamPairs("mlb", MLB_ABBREVIATIONS);
export const NBA_TEAMS = toTeamPairs("nba", NBA_ABBREVIATIONS);
